import { IStoreSupportFaqItem } from '@gn-audio/core/api/store-support/models/store-support-faq-item';
import { Component, Input, Inject, OnInit } from 'angular-ts-decorators';

import { CategoryFaqsBaseComponent } from '../models/category-faqs-base.component';

import template from './category-faqs.component.html';

@Component({
  selector: 'categoryFaqs',
  template,
})
export class CategoryFaqsComponent extends CategoryFaqsBaseComponent implements OnInit {
  public static $inject: ReadonlyArray<string> = ['$q'];

  constructor(
      @Inject('$q') $q: ng.IQService,
      @Inject('$log') private $log: ng.ILogService) {      
    super($q);
  }
  @Input() public category?: string;

  public faqItems: IStoreSupportFaqItem[] = [];

  public ngOnInit() {
    this.loadFaqItems(this.category);
  }

  private loadFaqItems(category: string): ng.IPromise<any> | undefined {
    if (category?.length === 0) {
      return;
    }

    this.$q
      .when(this.getFaqs(category))
      .then((faqs: IStoreSupportFaqItem[] | null) => {
        if (!faqs) {
          this.$log.warn(`Cannot load Faq items for category: ${category}`);
          return;
        }
        this.faqItems = faqs;       
      });
  }
}
